import { useState, useEffect } from "react";
import { Spin } from "antd";
import MediaQuery from "react-responsive";

import API from "scripts/api";

import LoadMore from "components/loadmore";
import PWACard from "components/job-card/pwa";
import SPACard from "components/job-card/spa";
import Empty from "pages/empty";

const Component = () => {
	const initialState = {
		list: [],
	};
	const [state, setState] = useState(initialState);
	const { list, loaded, loading, loadMore, page } = state;

	const handleData = (params) => {
		if (!loading) {
			setState((prevState) => ({ ...prevState, loading: true }));

			params.pageSize = 12;

			API.profile
				.bookmarkedJobs(params)
				.then(({ data, meta: { currentPage, perPage, total } }) => {
					setState((prevState) => ({
						...prevState,
						loaded: true,
						loading: false,
						loadMore: total > currentPage * perPage,
						list: [...list, ...data],
						page: currentPage,
					}));
				})
				.catch(() => {
					setState((prevState) => ({ ...prevState, loading: false }));
				});
		}
	};

	const handleLoadmore = () => {
		handleData({ page: page + 1 });
	};

	const componentDidMount = () => {
		handleData({});
	};

	useEffect(componentDidMount, []);

	return loaded ? (
		<div className="panel-bookmarks">
			{loaded ? (
				list.length ? (
					<>
						<div className="list">
							<ul className="row">
								{list.map((job) => (
									<li
										className="col-12 col-md-6 col-xl-4"
										key={job.id}
									>
										<MediaQuery minWidth={992}>
											<SPACard {...job} />
										</MediaQuery>
										<MediaQuery maxWidth={992}>
											<PWACard {...job} />
										</MediaQuery>
									</li>
								))}
							</ul>
						</div>
						{loadMore && (
							<LoadMore
								onScreen={handleLoadmore}
								loading={loading}
							/>
						)}
					</>
				) : (
					<Empty />
				)
			) : (
				<Spin />
			)}
		</div>
	) : (
		<Spin className="page-loading" />
	);
};

export default Component;
